import { render, staticRenderFns } from "./ShoppingListsSelector.vue?vue&type=template&id=34cab238&scoped=true&"
import script from "./ShoppingListsSelector.vue?vue&type=script&lang=js&"
export * from "./ShoppingListsSelector.vue?vue&type=script&lang=js&"
import style0 from "./ShoppingListsSelector.vue?vue&type=style&index=0&id=34cab238&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34cab238",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Tick: require('/vercel/path0/components/icons/Tick.vue').default})
